import axios from "axios";
import store from "../store/index.js";
const baseURL = require("@/config/APIs").API;

const setTitle = title => {
  document.title = title;
};
function getDomain(name) {
  let testENVs = ["localhost", "sit", "dev", "uat"];
  let testENV = "";
  testENVs.forEach(env => {
    if (location.hostname.includes(env)) {
      testENV = env;
    }
  });
  let temp = testENV ? testENV + ".cmft.com" : "cmft.com";
  //本地开发不加domain
  // let domain = testENV === 'localhost' ? '': (name === '_a'? temp:location.hostname)//租户项目仅用于用户版
  let domain =
    testENV === "localhost"
      ? ""
      : name === "_a" || name.includes("_name") || name.includes("_pub")
      ? temp
      : location.hostname; //租户项目仅用于用户版
  // let domain = testENV === 'localhost' ? '': temp
  return domain;
}

async function choiceTokenFromCookie(auths) {
  for (var c of auths) {
    try {
      let response = await axios.get(baseURL + "/v1/edit-user", {
        headers: { "X-Auth-Token": c }
      });
      if (response.status < 400) {
        localStorage.set_x_auth_token = "true";
        localStorage.x_auth_token = c;
        return c;
      }
    } catch (err) {
      // console.log(err)
    }
  }
  localStorage.set_x_auth_token = "false";
  localStorage.x_auth_token = null;
  return null;
}

//所有租户项目在cookie里的操作都是为将租户项目带入其他域名
function generateKeys() {
  let testENV = ["localhost", "sit", "dev", "uat"].find(item =>
    location.hostname.includes(item)
  );
  let arr = [
    "tenant_id",
    "tenant_name",
    "project_id",
    "project_name",
    "tenant_id_pub",
    "project_id_pub"
  ];
  if (testENV === "localhost" || !testENV) {
    return arr;
  } else {
    return arr.map(item => {
      return item + "_" + testENV;
    });
  }
}
var UTFTranslate = {
  Change: function(pValue) {
    return pValue.replace(/[^\u0000-\u00FF]/g, function($0) {
      return escape($0).replace(/(%u)(\w{4})/gi, "&#x$2;");
    });
  },
  ReChange: function(pValue) {
    return unescape(
      pValue
        .replace(/&#x/g, "%u")
        .replace(/\\u/g, "%u")
        .replace(/;/g, "")
    );
  }
};
// function get_set_x_auth_token () {
//   return localStorage.set_x_auth_token === 'false'|| localStorage.set_x_auth_token === undefined?false:true
// }

export const cookies = {
  setAuthorization: value => {
    localStorage.set_x_auth_token = "true";
    localStorage.x_auth_token = value;
    cookies.setCookie("_a", value);
  },
  getAuthorization: async () => {
    let auths = cookies.getCookieAsArray("_a");
    let token = ""; // eslint-disable-line no-unused-vars
    if (!auths.length || !auths.every(item => !!item)) {
      store.commit("changeloginState", false);
      return null;
    } else {
      //云门户自己 有cookie就不再去探测
      let localStorageCookie = localStorage.getItem("x_auth_token");
      if (auths.includes(localStorageCookie)) {
        store.commit("changeloginState", true);
        return localStorageCookie;
      }
      //其他域名系统退出时无法删除云门户域名下localstorage
      token = await choiceTokenFromCookie(auths);
      if (token) {
        store.commit("changeloginState", true);
      }
      return token;
    }
    // // 如果x_auth_token有效且与现有_a cookie都不匹配
    // // 说明可能已经过期并在其他网站重新登录，需要重置x_auth_token，重新生成
    // if (get_set_x_auth_token() && !auths.includes(localStorage.x_auth_token)) {
    //   localStorage.set_x_auth_token = 'false'
    //   localStorage.x_auth_token = null
    // }
    // let set_x_auth_token = get_set_x_auth_token()
    // if (!set_x_auth_token) {
    //   await choiceTokenFromCookie(auths)
    //   set_x_auth_token = get_set_x_auth_token()
    // }
    // return set_x_auth_token?localStorage.x_auth_token:null
  },
  deleteAuthorization: () => {
    localStorage.set_x_auth_token = "false";
    localStorage.x_auth_token = null;
    cookies.delCookie("_a");
    store.commit("changeloginState", false);
  },
  setCookie: (name, value) => {
    const Days = 0.5;
    const exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    let str = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
    let domain = getDomain(name);
    if (domain) {
      str += ";domain=" + domain;
    }
    document.cookie = str;
  },
  getCookieAsArray: name => {
    let cookie_str = document.cookie;
    let cookie_parts = cookie_str.split(";");
    let results = [];
    cookie_parts.forEach(c => {
      if (c) {
        if (c.indexOf("=") === -1) {
          c = "_a=" + c;
        }
        let kv = c.split("=");
        let k = kv[0].trim();
        let v = kv[1].trim();
        if (k == name) {
          results.push(v);
        }
      }
    });
    return results;
  },
  delCookie: name => {
    const exp = new Date();
    exp.setDate(exp.getDate() - 1);
    let str = name + "=" + escape("") + ";expires=" + exp.toGMTString();
    let domain = getDomain(name);
    if (domain) {
      str = str + ";domain=" + domain;
    }
    document.cookie = str;
  },
  //所有租户项目在cookie里的操作都是为将租户项目带入其他域名
  delTenantProject: () => {
    let keys = generateKeys();
    for (let i = 0; i < 6; i++) {
      cookies.delCookie(keys[i]);
    }
  },
  setTenantProject: (tenant, project) => {
    let keys = generateKeys();
    let vals = [
      tenant.id,
      tenant.name,
      project.id,
      project.name,
      tenant.id,
      project.id
    ];
    for (let i = 0; i < 6; i++) {
      cookies.setCookie(keys[i], vals[i]);
    }
  },
  getTenantProject: () => {
    let cookieList = document.cookie
      .split(";")
      .map(item => {
        let arr = item.trim().split("=");
        let obj = {};
        if (arr.length === 2) {
          obj[arr[0].trim()] = arr[1].trim();
        }
        return obj;
      })
      .reduce((obj, item) => Object.assign({}, obj, item), {});
    let obj = { project: null, tenant: null };
    let keys = generateKeys();
    obj.project = {
      name: cookieList[keys[3]]
        ? UTFTranslate.ReChange(cookieList[keys[3]])
        : cookieList[keys[3]],
      id: cookieList[keys[2]]
    };
    obj.tenant = {
      name: cookieList[keys[1]]
        ? UTFTranslate.ReChange(cookieList[keys[1]])
        : cookieList[keys[1]],
      id: cookieList[keys[0]]
    };
    obj.tenant_pub = {
      name: cookieList[keys[1]]
        ? UTFTranslate.ReChange(cookieList[keys[1]])
        : cookieList[keys[1]],
      id: cookieList[keys[4]]
    };
    obj.project_pub = {
      name: cookieList[keys[3]]
        ? UTFTranslate.ReChange(cookieList[keys[3]])
        : cookieList[keys[3]],
      id: cookieList[keys[5]]
    };
    return obj;
  }
};

export default {
  setTitle
};



// WEBPACK FOOTER //
// ./src/common/cookieUtils.js